export abstract class Command<TResult> {
  protected readonly __resultType?: TResult;
}
